import { render, staticRenderFns } from "./ModalInfoPay.vue?vue&type=template&id=5990bc44"
import script from "./ModalInfoPay.vue?vue&type=script&lang=js"
export * from "./ModalInfoPay.vue?vue&type=script&lang=js"
import style0 from "./ModalInfoPay.vue?vue&type=style&index=0&id=5990bc44&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports